module.exports = __webpack_public_path__ + "img/qx80-20.9a217d04.png";